export default __webpack_public_path__ + "static/media/no-docs.9ab8b4b9.png";